module.exports = __webpack_public_path__ + "static/media/percentage_gray.2f1df0a2.svg";